import { Component, OnDestroy, OnInit } from '@angular/core'
import { MatIconRegistry } from '@angular/material/icon'
import { DomSanitizer } from '@angular/platform-browser'
import { Subscription } from 'rxjs'
import { distinctUntilChanged, filter } from 'rxjs/operators'
import { NotificationService } from "../../notification/shared/notification.service"
import { Client } from "../shared/client/client"
import { ClientService } from "../shared/client/client.service"
import { BillingService } from "./shared/billing.service"

@Component({
  selector: 'app-billing',
  templateUrl: './billing.component.html',
  styleUrls: ['./billing.component.scss']
})
export class BillingComponent implements OnInit, OnDestroy {
  sub: Subscription = new Subscription()
  client: Client = null
  subClient: Subscription
  isDownload = false
  URL = null

  constructor(private billingService: BillingService,
    protected clientService: ClientService,
    protected notificationService: NotificationService,
    protected matIconRegistry: MatIconRegistry,
    protected domSanitizer: DomSanitizer
  ) {
    this.generateMatIcon()
  }

  ngOnInit(): void {
    this.subClient = this.clientService.currentClient$.pipe(filter(client => client != null)).pipe(distinctUntilChanged((prev, current) => prev.id == current.id)).subscribe(client => {
      this.client = client
      this.billingService.getLeanPayURL(this.client).subscribe(
        response => this.URL = response,
        error => this.URL = null
      )
    })
  }

  ngOnDestroy() {
    this.sub.unsubscribe()
    if (this.subClient) {
      this.subClient.unsubscribe()
    }
  }

  exportGlobal() {
    this.isDownload = true
    this.sub.unsubscribe()
    this.sub = this.billingService.exportCalendarBillings(this.client).subscribe(response => {
      this.isDownload = false
    }, err => {
      this.notificationService.notif(err.message, "error")
      this.isDownload = false
    })
  }

  leanpay() {
    if (this.URL) {
      window.open(this.URL, '_blank');
    }
  }

  generateMatIcon(): void {
    this.matIconRegistry.addSvgIcon(
      'leanpay',
      this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/pictogrammes/leanpay-logo.svg')
    )
    this.matIconRegistry.addSvgIcon(
      'calendar',
      this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/pictogrammes/calendar.svg')
    )
  }

  showCalendar() {
    return this.client.site.is_on_hermine;
  }
}
